import { render, staticRenderFns } from "./datum.vue?vue&type=template&id=fcb29cec&scoped=true&"
import script from "./datum.vue?vue&type=script&lang=js&"
export * from "./datum.vue?vue&type=script&lang=js&"
import style0 from "./datum.vue?vue&type=style&index=0&id=fcb29cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb29cec",
  null
  
)

export default component.exports